{
  "name": "eye-able-dashboard",
  "type": "module",
  "version": "2.1.18",
  "private": true,
  "proxy": "http://localhost:3000/",
  "author": "Eye-Able",
  "license": "",
  "description": "",
  "scripts": {
    "clean": "git clean -fdx dist/ node_modules/",
    "start": "vite --host 0.0.0.0 --port 5177 --cors --strictPort",
    "build": "NODE_OPTIONS=--max-old-space-size=8192 vite build",
    "preview": "vite preview",
    "test:e2e": "playwright test --config=playwright-tests/playwright.config.ts --project=admin-chromium --project=customer-chromium --project=partner-chromium --project=sales-chromium",
    "test:e2e:audit": "node playwright-tests/scripts/run-accessibility-audit.mjs",
    "test": "vitest",
    "test:ci": "vitest run",
    "test:ui": "vitest --ui --coverage",
    "test:coverage": "vitest run --coverage",
    "postinstall": "node scripts/copy-assets.js"
  },
  "dependencies": {
    "@azure/msal-browser": "^3.28.0",
    "@azure/msal-react": "^2.2.0",
    "@dnd-kit/core": "6.1.0",
    "@dnd-kit/modifiers": "7.0.0",
    "@dnd-kit/sortable": "8.0.0",
    "@dnd-kit/utilities": "3.2.2",
    "@emotion/react": "11.13.3",
    "@emotion/styled": "11.14.1",
    "@eye-able/ui": "file:../../libs/ui",
    "@git-diff-view/file": "^0.1.3",
    "@git-diff-view/react": "^0.1.3",
    "@hookform/resolvers": "^5.2.2",
    "@lexical/code": "^0.49.0",
    "@lexical/code-prism": "^0.49.0",
    "@lexical/link": "^0.49.0",
    "@lexical/list": "^0.49.0",
    "@lexical/mark": "^0.49.0",
    "@lexical/overflow": "^0.49.0",
    "@lexical/plain-text": "^0.49.0",
    "@lexical/react": "^0.49.0",
    "@lexical/rich-text": "^0.49.0",
    "@lexical/selection": "^0.49.0",
    "@lexical/utils": "^0.49.0",
    "@mui/icons-material": "6.1.6",
    "@mui/lab": "6.0.0-beta.14",
    "@mui/material": "6.1.6",
    "@mui/x-date-pickers": "7.22.1",
    "@posthog/react": "^1.9.0",
    "@sentry/react": "^10.70.0",
    "@tabler/icons-react": "^3.46.0",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/react-query": "5.104.1",
    "@tanstack/react-table": "^8.21.3",
    "@tanstack/react-virtual": "^3.14.13",
    "@types/mime-types": "^3.0.1",
    "chroma-js": "3.1.2",
    "color": "^5.0.0",
    "date-fns": "^4.1.0",
    "dompurify": "^3.4.13",
    "export-to-csv": "1.4.0",
    "final-form": "4.20.10",
    "final-form-focus": "1.1.2",
    "html-react-parser": "^5.2.6",
    "i18next": "26.4.2",
    "i18next-browser-languagedetector": "8.2.1",
    "i18next-http-backend": "4.0.2",
    "jotai": "2.10.1 ",
    "js-beautify": "2.0.3",
    "languagedetect": "2.0.0",
    "lexical": "0.49.0",
    "lodash-es": "4.18.1",
    "lucide-react": "^1.7.0",
    "material-react-table": "3.0.1",
    "mime-types": "^3.0.2",
    "mui-chips-input": "3.1.1",
    "mui-rff": "8.0.1",
    "mui-tel-input": "6.0.1",
    "nanoclone": "1.0.2",
    "parse-numeric-range": "1.3.0",
    "pdf-lib": "^1.17.1",
    "posthog-js": "^1.407.2",
    "prop-types": "15.8.1",
    "qrcode.react": "^4.2.0",
    "react": "18.3.1",
    "react-colorful": "5.6.1",
    "react-day-picker": "^9.11.2",
    "react-dom": "18.3.1",
    "react-dropzone": "14.3.5",
    "react-final-form": "6.5.9",
    "react-hook-form": "^7.66.1",
    "react-i18next": "17.0.16",
    "react-joyride": "3.2.0",
    "react-markdown": "^10.1.0",
    "react-pdf": "10.4.1",
    "react-router-dom": "7.18.2",
    "react-syntax-highlighter": "16.1.1",
    "recharts": "^3.8.1",
    "rehype-raw": "7.0.0",
    "remark-gfm": "4.0.1",
    "sanitize-filename": "^1.6.4",
    "tailwind-merge": "^3.4.0",
    "tailwindcss": "^4.3.3",
    "verapdf-js-viewer": "veraPDF/verapdf-js-viewer#v1.7.46",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "yup": "1.4.0",
    "zod": "^3.25.76",
    "zustand": "^5.0.3"
  },
  "devDependencies": {
    "@eye-able-projects/eye-able-audit-plugin": "^1.0.13-rc1",
    "@playwright/test": "^1.61.1",
    "@sentry/vite-plugin": "5.4.0",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/chroma-js": "^3.1.2",
    "@types/color": "^4.2.0",
    "@types/js-beautify": "^1.14.3",
    "@types/lodash-es": "^4.17.12",
    "@types/react": "18.3.12",
    "@types/react-dom": "18.3.1",
    "@types/react-syntax-highlighter": "^15.5.13",
    "@vitejs/plugin-react": "6.1.2",
    "@vitest/coverage-v8": "^4.0.18",
    "@vitest/ui": "^4.0.18",
    "fs-extra": "11.4.0",
    "happy-dom": "^20.8.9",
    "typescript": "^5.9.3",
    "vite": "^8.3.3",
    "vite-plugin-dynamic-import": "1.6.0",
    "vitest": "^4.1.11"
  },
  "packageManager": "npm@11.7.0",
  "browserslist": {
    "production": [
      ">0.5%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  }
}
